import React from 'react';
import { motion } from 'framer-motion';
import { Ruler, Palette, Wrench, Sparkles, Phone } from 'lucide-react';

const VISIT_IMG = 'https://images.pexels.com/photos/6527029/pexels-photo-6527029.jpeg?auto=compress&cs=tinysrgb&w=900&q=85';

const benefits = [
  {
    Icon: Ruler,
    title: 'Kostenloses Aufmaß',
    desc: 'Wir kommen zu Ihnen und nehmen alle Maße präzise auf — in ganz Berlin.',
  },
  {
    Icon: Palette,
    title: 'Vor-Ort-Beratung',
    desc: 'Wir bringen Stoffmuster mit — Sie sehen das Ergebnis direkt in Ihren Räumen.',
  },
  {
    Icon: Wrench,
    title: 'Fachgerechte Montage',
    desc: 'Unser erfahrenes Team montiert alles sauber, zuverlässig und pünktlich.',
  },
  {
    Icon: Sparkles,
    title: 'Nachher-Reinigung',
    desc: 'Auf Wunsch reinigen und pflegen wir Ihre neuen Gardinen bei der Erstmontage.',
  },
];

const HouseVisits = () => (
  <section
    id="beratung"
    data-testid="house-visits-section"
    className="py-28 bg-[#EDE8E0]/40"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
          className="relative order-2 lg:order-1"
          data-testid="house-visits-image"
        >
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={VISIT_IMG}
              alt="Wir kommen zu Ihnen — Vor-Ort-Beratung in Berlin"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="absolute -top-4 -left-4 w-full h-full border border-[#8B7355]/25 -z-10" />
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
          className="order-1 lg:order-2"
        >
          <span className="text-[11px] tracking-[0.22em] uppercase text-[#8B7355] font-outfit mb-4 block">
            Hausbesuche & Beratung
          </span>
          <h2 className="font-cormorant text-4xl md:text-5xl text-[#2A2A2A] font-medium mb-4 leading-tight">
            Wir kommen zu Ihnen — in ganz Berlin.
          </h2>
          <p className="font-outfit text-base text-[#2A2A2A]/65 leading-relaxed mb-10">
            Sie müssen nicht zu uns kommen. Unser Team kommt zu Ihnen — mit Stoffmustern, Messwerkzeug und dem nötigen Fachwissen für ein perfektes Ergebnis.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-12">
            {benefits.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex items-start gap-4 bg-white border border-[#EDE8E0] p-5"
                data-testid={`benefit-card-${i}`}
              >
                <div className="flex-shrink-0 w-9 h-9 bg-[#F8F5F0] border border-[#EDE8E0] flex items-center justify-center">
                  <item.Icon size={15} className="text-[#8B7355]" />
                </div>
                <div>
                  <h4 className="font-cormorant text-base text-[#2A2A2A] font-semibold mb-1">
                    {item.title}
                  </h4>
                  <p className="font-outfit text-xs text-[#2A2A2A]/60 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          <a
            href="tel:+493043115080"
            data-testid="visits-cta-phone"
            className="inline-flex items-center gap-2.5 bg-[#8B7355] text-white px-8 py-4 font-outfit text-xs tracking-[0.18em] uppercase hover:bg-[#6B5440] transition-colors duration-200"
          >
            <Phone size={13} />
            Termin vereinbaren
          </a>
        </motion.div>
      </div>
    </div>
  </section>
);

export default HouseVisits;
